import React, { useState, useContext, useEffect, useRef } from "react";
import { useQuery } from "@apollo/client";
import { useRouter } from "next/router";
import { BetQLService } from "src/common-services";
import { getGameLeague, PERIODS, useGame } from "src/services/EventService";
import { SubscriptionContext } from "src/services/SubscriptionService";
import { useContainerQuery } from "src/services/UtilService";
import { BEST_LINES_QUERY } from "src/gql/queries";
import { STATES } from "src/constants";
import MobileGameLinesRow from "./MobileGameLinesRow";
import GameLinesRow from "./GameLinesRow";
import GameLineNav from "./GameLineNav";
export interface StateItem {
  value: string | null;
  name: string;
}

const ALL_STATE = {
  value: null,
  name: "All States",
};

export const STATE_LIST: StateItem[] = [
  ALL_STATE,
  ...STATES.reduce((arr: StateItem[], s: StateItem) => {
    s.name = BetQLService.titleCase(s.name);
    if (s.name !== "Other") {
      arr.push(s);
    }
    return arr;
  }, []),
];

const GameLines = ({ slugId }: { slugId: string }) => {
  const router = useRouter();
  const { game } = useGame({ slug: slugId });
  const league = game && getGameLeague(game);
  const routeSport = typeof router.query.sport === "string" ? router.query.sport : undefined;
  const isWorldCup = league?.key === "WC" || routeSport === "soccer-world-cup" || game?.league?.name === "WC";

  const [lineType, setLineType] = useState(league?.key === "MLB" || isWorldCup ? "FGmoneyline" : "combined");
  const { userLocale } = useContext(SubscriptionContext);
  const [stateIndex, setStateIndex] = useState(0);
  const container = useRef(null);

  const { data, loading } = useQuery(BEST_LINES_QUERY, {
    ssr: false,
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
    variables: {
      slugId,
      period: Object.keys(PERIODS),
      locale: STATE_LIST[stateIndex].value,
    },
  });

  useEffect(() => {
    const initialIndex = Math.max(
      0,
      STATE_LIST.findIndex((c) => c.value === userLocale)
    );
    setStateIndex(initialIndex);
  }, []);

  useEffect(() => {
    if ((league?.key === "MLB" || isWorldCup) && lineType === "combined") {
      setLineType("FGmoneyline");
    }
  }, [league?.key, isWorldCup, lineType]);

  let books = data?.books ?? [];
  if (isWorldCup) {
    books = books.filter((book: any) => book.name !== "Fanatics");
  }
  const sportscubeOdds = game?.sportscubeOdds;

  const favLineType = league?.favoriteLine ?? "moneyline";
  const displayLineType = lineType === "combined" ? favLineType : lineType;

  const sizeContainer = useContainerQuery(container, {
    small: 768,
    medium: 1200,
    large: Infinity,
  });

  return (
    <div ref={container} className="games-detail-lines-con">
      <GameLineNav
        setLineType={setLineType}
        setStateIndex={setStateIndex}
        selectedLineType={lineType}
        selectedStateIndex={stateIndex}
        currentSportObj={league}
        hideCombined={isWorldCup}
        size={sizeContainer}
      />

      <GameLinesRow
        lineType={lineType}
        game={game}
        currentSportObj={league}
        books={books}
        sportscubeOdds={sportscubeOdds}
        loading={loading}
        size={sizeContainer}
      />
      <MobileGameLinesRow
        lineType={displayLineType}
        game={game}
        currentSportObj={league}
        books={books}
        sportscubeOdds={sportscubeOdds}
        loading={loading}
        size={sizeContainer}
      />
    </div>
  );
};

export default GameLines;
